{
  "colorFormat": "Formato da cor",
  "hex": "Hexagonal",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
